// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerFree extends SceneLayer {
	/**
	 * Vytvoreni vrstvy pro 3d - routovac, zobrazeni trasy.
	 *
	 * @param {String} name ID-nazev vrstvy
	 * @param {Array[]} lines Body trasy - pole poli
	 * @param {Array[]} [style.lineColor = cervena] Barva cary
	 * @param {Array[]} [style.lineWidth = 14] Sirka cary
	 * @param {Array[]} [style.lineOffset = [0, 0, 0]] Offset cary
	 * @param {Array[]} [style.outlineColor = bila] Barva outline cary
	 * @param {Array[]} [style.outlineWidth = 22] Sirka outline cary
	 * @param {Array[]} [style.outlineWidth = 22] Sirka outline cary
	 * @param {Array[]} [style.outlineOffset = [0, 0, 0]] Offset outline cary
	 */
	constructor(scene, itemId, name, lines, style = {}) {
		super(scene, itemId);

		this._name = name;
		this._lines = lines;
		this._style = {
			lineColor: [255, 0, 0, 255],
			lineWidth: 14,
			lineOffset: [0, 0, 0],
			outlineColor: [255, 255, 255, 255],
			outlineWidth: 22,
			outlineOffset: [0, 0, 0],
			...style,
		};
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerFree",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd: any = super.getCreateData();

		rd.name = this._name;
		rd.lines = this._lines;
		rd.style = this._style;

		return rd;
	}
}
